import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { ReactComponent as SortTilesSvg } from '@assets/icons/sort-tiles.svg';
import { ReactComponent as SortListSvg } from '@assets/icons/sort-list.svg';

import './ControlPanel.less';

const SEARCH_PARAM = 'search';
const VIEW_PARAM = 'view';

const DEFAULT_VIEW = 'tiles';

type ViewType = 'tiles' | 'list';

function ControlPanel() {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchQuery = searchParams.get(SEARCH_PARAM) ?? '';
  const viewValue = searchParams.get(VIEW_PARAM) ?? DEFAULT_VIEW;

  const onSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      const updatedParams = new URLSearchParams(searchParams);
      if (value.trim()) {
        updatedParams.set(SEARCH_PARAM, value);
      } else {
        updatedParams.delete(SEARCH_PARAM);
      }
      setSearchParams(updatedParams, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  const onViewSelect = useCallback(
    (view: ViewType) => {
      const updatedParams = new URLSearchParams(searchParams);
      if (view === DEFAULT_VIEW) {
        updatedParams.delete(VIEW_PARAM);
      } else {
        updatedParams.set(VIEW_PARAM, view);
      }
      setSearchParams(updatedParams, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  return (
    <div className="reviewer-control-panel">
      <div className="reviewer-control-panel-search">
        <Input
          size="large"
          placeholder="Search files"
          prefix={<SearchOutlined />}
          className="search_input"
          value={searchQuery}
          onChange={onSearchChange}
        />
      </div>

      <div className="reviewer-control-panel-view">
        <button
          type="button"
          className="reviewer-control-panel-btn"
          style={{ opacity: viewValue === 'tiles' ? 1 : 0.5 }}
          onClick={() => onViewSelect('tiles')}
        >
          <SortTilesSvg className="b-tile-icon" />
        </button>
        <div className="line" />
        <button
          type="button"
          className="reviewer-control-panel-btn"
          style={{ opacity: viewValue === 'list' ? 1 : 0.5 }}
          onClick={() => onViewSelect('list')}
        >
          <SortListSvg className="b-list-icon" />
        </button>
      </div>
    </div>
  );
}
export default ControlPanel;
